module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-expand-transition', [(_vm.isCompact) ? _c('div', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeCompact(false)
      }
    }
  }, [_vm._v("Add Outstandings")])], 1) : _vm._e()]), _vm._v(" "), _c('v-expand-transition', [(!_vm.isCompact) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "quick-input",
    attrs: {
      "rows": "7",
      "placeholder": "Paste items and separate with new line. Click save..."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.demoData($event)
      }
    }
  }, [_vm._v("Sample")]), _vm._v(" | \n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('val')
      }
    }
  }, [_vm._v("Val")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('cos')
      }
    }
  }, [_vm._v("COS")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('pay')
      }
    }
  }, [_vm._v("Payslips")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('lmi')
      }
    }
  }, [_vm._v("LMI")]), _vm._v(" \n            "), (_vm.items.length) ? _c('v-btn', {
    on: {
      "click": _vm.saveItems
    }
  }, [_vm._v("Save " + _vm._s(_vm.items.length) + " Items")]) : _vm._e(), _vm._v(" "), (!_vm.items.length) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeCompact(true)
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee93d68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ImportItems.vue
// module id = 2620
// module chunks = 1